export function pathOnly( url ) {
  let urlPath = url.replace(/^https?:\/\/\w+(\.\w+)+/g, '');
  return urlPath === '/' ? url : urlPath;
}
